import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  error: null,
  loading: false,
};

const trainingsRegisterStart = (state) => (
  updateObject(state, {
    error: null,
    loading: true,
  })
);

const trainingsRegisterSuccess = (state) => (
  updateObject(state, {
    error: null,
    loading: false,
  })
);

const trainingsRegisterFail = (state, action) => (
  updateObject(state, {
    error: action.error,
    loading: false,
  })
);

const reducer = (state = initialState, action = null) => {
  switch (action.type) {
    case actionTypes.TRAININGS_REGISTER_START:
      return trainingsRegisterStart(state);
    case actionTypes.TRAININGS_REGISTER_SUCCESS:
      return trainingsRegisterSuccess(state);
    case actionTypes.TRAININGS_REGISTER_FAIL:
      return trainingsRegisterFail(state, action);
    default:
      return state;
  }
};

export default reducer;
